import { useContext } from 'react';
import { mapModes } from '../../constants/map';
import { MapContext } from '../../contexts/MapContext';
import LayerFeatureToolbar from './LayerFeatureToolbar';
import LayerToolbar from './LayerToolbar';
import SectionToolbar from './SectionToolbar';
import ViewToolbar from './ViewToolbar';
import MultiSectionToolbar from './MultiSectionToolbar';
import SectionGroupToolbar from './SectionGroupToolbar';
import MeasurementToolbar from './MeasurementToolbar';
import MultiLayerFeatureToolbar from './MultiLayerFeatureToolbar';

const MapToolbar = () => {
  const {
    mapState: {
      mapMode,
      activeLayerId,
      activeLayerFeatureId,
      selectedLayerFeatureIds,
    },
  } = useContext(MapContext);

  return (
    <div className="d-flex justify-content-end align-items-center">
      {mapMode === mapModes.VIEW ? (
        <ViewToolbar />
      ) : mapMode === mapModes.MULTI_SECTION_SELECT ? (
        <MultiSectionToolbar />
      ) : mapMode === mapModes.SECTION_GROUP_ENGAGED ? (
        <SectionGroupToolbar />
      ) : mapMode === mapModes.MEASUREMENT ? (
        <MeasurementToolbar />
      ) : selectedLayerFeatureIds?.size ? (
        <MultiLayerFeatureToolbar />
      ) : activeLayerFeatureId ? (
        <LayerFeatureToolbar />
      ) : activeLayerId ? (
        <LayerToolbar />
      ) : (
        <SectionToolbar />
      )}
    </div>
  );
};

export default MapToolbar;
